import { z } from 'zod';

export const HealthCheckSchema = z.object({
  ok: z.boolean(),
  latencyMs: z.number().nonnegative().optional(),
  error: z.string().optional(),
});

export const HealthResponseSchema = z.object({
  /** ok: all checks pass. degraded: Aroo DB fine, dt_spar unreachable. error: Aroo DB down. */
  status: z.enum(['ok', 'degraded', 'error']),
  timestamp: z.iso.datetime(),
  uptimeSeconds: z.number().nonnegative(),
  checks: z.object({
    aroo: HealthCheckSchema,
    dtspar: HealthCheckSchema,
  }),
});

export type HealthCheck = z.infer<typeof HealthCheckSchema>;
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
